<template>
  <div
    :class="[
      'columns ugc-new-steps-view-instructions',
      {
        'small-10 medium-8 small-offset-1 medium-offset-2': this.$store.state.utils.configuration.enableNewUgcModal,
      }
    ]"
  >
    {{ getTitle }}
  </div>
</template>

<script>
export default {
  name: "UgcNewStepsView",
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    getUgcFlowViews() {
      return this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].ugcFlowViews;
    },
    getCurrentUgcView() {
      return this.$store.state.ugc.stateManager.currentUgcView;
    },
    getTitle() {
      if (
        this.getUgcFlowViews[this.getCurrentUgcView] == "ugc-almost-done"
        || this.getUgcFlowViews[this.getCurrentUgcView] == "new-ugc-almost-done"
      ) {
        return this.translations.ugcInterModalHeader;
      } else if (
        this.getUgcFlowViews[this.getCurrentUgcView] == "ugc-confirm-design"
        || this.getUgcFlowViews[this.getCurrentUgcView] == "ugc-new-confirm-design"
        || this.getUgcFlowViews[this.getCurrentUgcView] == "ugc-confirm-design-step"
      ) {
        if (this.$store.state.utils.configuration.enableNewUgcModal || this.$store.state.utils.configuration.ugc.enableUgcConfirmDesignStep )
          return this.translations.ugcConfirmDesc2;
        return this.translations.ugcConfirmDesc;
      }
      return this.translations.ugcHeaderStepTitle;

    },
    componentName() {
      return this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].activeUGCComponent;
    },
  },
};
</script>
